var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 61,
    viewBox: "0 0 66 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2047 23.0254H63.0734C64.6671 23.0254 65.959 24.3173 65.959 25.911V41.2762C65.959 47.1334 61.2108 51.8816 55.3536 51.8816H55.3035C49.4462 51.8824 44.6974 47.1349 44.6965 41.2777C44.6965 41.2772 44.6965 41.2767 44.6965 41.2761V24.5335C44.6966 23.7006 45.3718 23.0254 46.2047 23.0254Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6057 19.9881C61.3802 19.9881 64.4401 16.9282 64.4401 13.1537C64.4401 9.37918 61.3802 6.31934 57.6057 6.31934C53.8312 6.31934 50.7714 9.37918 50.7714 13.1537C50.7714 16.9282 53.8312 19.9881 57.6057 19.9881Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3431 19.9884C41.7951 19.9884 46.2149 15.5686 46.2149 10.1165C46.2149 4.66441 41.7951 0.244629 36.3431 0.244629C30.891 0.244629 26.4712 4.66441 26.4712 10.1165C26.4712 15.5686 30.891 19.9884 36.3431 19.9884Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5076 23.0254H21.6628C20.0881 23.0644 18.8425 24.3712 18.879 25.946V43.4708C18.6591 52.9208 26.1355 60.7628 35.5852 60.9941C45.035 60.7628 52.5113 52.9208 52.2915 43.4708V25.946C52.3279 24.3712 51.0823 23.0644 49.5076 23.0254Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.1026 23.0254V47.5835C37.095 48.7097 36.4126 49.7214 35.3712 50.1502C35.0397 50.2905 34.6833 50.3628 34.3233 50.3628H20.2141C20.0167 49.8617 19.8345 49.3605 19.6826 48.8441C19.1509 47.1014 18.8797 45.2897 18.8776 43.4677V25.9414C18.8411 24.3691 20.0847 23.0644 21.6569 23.0254H37.1026Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.5839 23.0254V49.1023C35.5838 49.4623 35.5115 49.8186 35.3712 50.1502C34.9425 51.1916 33.9307 51.874 32.8046 51.8816H20.928C20.6698 51.3804 20.4268 50.8792 20.2141 50.3628C20.0015 49.8465 19.8345 49.3605 19.6826 48.8441C19.1509 47.1014 18.8797 45.2897 18.8776 43.4677V25.9414C18.8411 24.3691 20.0847 23.0644 21.6569 23.0254H35.5839Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.5838 23.0254V46.0648C35.5723 47.595 34.3347 48.8325 32.8045 48.8441H19.6826C19.1509 47.1014 18.8797 45.2897 18.8776 43.4677V25.9414C18.8411 24.3691 20.0847 23.0644 21.6569 23.0254H35.5838Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.0651 23.0254V46.0648C34.0535 47.595 32.8159 48.8325 31.2858 48.8441H19.6826C19.1509 47.1014 18.8797 45.2897 18.8776 43.4677V25.9414C18.8411 24.3691 20.0847 23.0644 21.6569 23.0254H34.0651Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.1029 15.1733V19.9574C36.8447 19.9726 36.6017 19.9878 36.3435 19.9878C36.0853 19.9878 35.8423 19.9726 35.5841 19.9574C35.0715 19.9234 34.563 19.842 34.0654 19.7144C30.9899 18.9861 28.4491 16.8292 27.231 13.9128C27.0214 13.423 26.8587 12.9145 26.745 12.394H34.3235C35.8561 12.3998 37.097 13.6408 37.1029 15.1733Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.5845 16.6924V19.9577C35.0719 19.9237 34.5635 19.8423 34.0658 19.7147C30.9903 18.9864 28.4495 16.8295 27.2314 13.9131H32.8052C34.3378 13.9189 35.5787 15.1598 35.5845 16.6924Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.5845 16.6924V19.9577C35.0719 19.9237 34.5635 19.8423 34.0658 19.7147C30.9903 18.9864 28.4495 16.8295 27.2314 13.9131H32.8052C34.3378 13.9189 35.5787 15.1598 35.5845 16.6924Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.0658 16.6924V19.7147C30.9903 18.9864 28.4495 16.8295 27.2314 13.9131H31.2865C32.8191 13.9189 34.06 15.1599 34.0658 16.6924Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43705 13.9131H31.2818C32.8192 13.9131 34.0656 15.1595 34.0656 16.6969V44.5416C34.0656 46.0791 32.8192 47.3255 31.2818 47.3255H3.43705C1.89956 47.3255 0.653198 46.0791 0.653198 44.5416V16.6969C0.653198 15.1595 1.89959 13.9131 3.43705 13.9131Z",
    fill: "url(#paint0_linear_17_44598)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6862 24.5116H19.12V39.6687H15.5737V24.5116H10.0333V21.5713H24.6862V24.5116Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_44598",
    x1: 6.45762,
    y1: 11.7378,
    x2: 28.2612,
    y2: 49.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/Microsoft_teams.22b8e6bea449da75482d3fd641226cc0.svg";
export { ForwardRef as ReactComponent };